export { default as EnrollmentSettingWrapper } from './component/EnrollmentSettingWrapper';
export const EnrollmentSettingDynamic = () => import('./component/EnrollmentSetting');
